{
  "amortizationProfile.Annuity": "Annuitetslån",
  "amortizationProfile.Bullet": "Stående lån",
  "amortizationProfile.Custom": "$t(common:unavailable)",
  "amortizationProfile.explanation": "* {{ profile }} beregnes med rentekonventionen {{ dayCountConvention }}, {{ paymentConvention }}",
  "amortizationProfile.Serial": "Serielån",
  "amortizationProfile.Standing": "Stående lån",
  "amortizationProfile.UnDefined": "$t(common:unavailable)",
  "changeMethod.placeholder": "Vælg metode",
  "changeMethod.ReducedPayment": "Lavere ydelse",
  "changeMethod.ReducedTimeToMaturity": "Kortere løbetid",
  "changeMethod.title": "Afdragsmetode",
  "customer.role.Access": "Adgang",
  "customer.role.AuthorizedToSign": "Tegningsberettiget",
  "dayCountConventions.A365Fix": "$t(common:unavailable)",
  "dayCountConventions.A365ISD": "$t(common:unavailable)",
  "dayCountConventions.Act_360": "Aktuelle/360",
  "dayCountConventions.Act_Act": "$t(common:unavailable)",
  "dayCountConventions.BELGIAN_365_365": "$t(common:unavailable)",
  "dayCountConventions.EURO_30_360": "$t(common:unavailable)",
  "dayCountConventions.ISDA_30_360": "$t(common:unavailable)",
  "dayCountConventions.NORMAL_30_360": "30/360",
  "dayCountConventions.UnDefined": "$t(common:unavailable)",
  "dayCountConventions.US_30_360": "30/360",
  "eventDescription.Conversion": "Konvertering",
  "eventDescription.NewInterestAgreement": "Ny renteaftale",
  "eventDescription.Ekstraordinært afdrag": "$t(enums:eventDescription.ExtraRepayment)",
  "eventDescription.ExtraRepayment": "Ekstraordinært afdrag",
  "eventDescription.Fuld indfrielse": "$t(enums:eventDescription.FullRedemption)",
  "eventDescription.FullRedemption": "Fuld indfrielse",
  "eventDescription.Indfrielse": "$t(enums:eventDescription.Redemption)",
  "eventDescription.LoanPartlyRedemption": "$t(enums:eventDescription.ExtraRepayment)",
  "eventDescription.LoanRedemption": "$t(enums:eventDescription.FullRedemption)",
  "eventDescription.NewLoan": "Nyt udlån",
  "eventDescription.Redemption": "Indfrielse",
  "fixedInterestPeriodType.Cheapest": "Billigste renteaftale",
  "fixedInterestPeriodType.ToMaturity": "Hele løbetiden",
  "fixedInterestPeriodType.UnDefined": "$t(common:unavailable)",
  "fixedInterestPeriodType.Years": "Årlig",
  "guaranteeRelation.GuarantorAlone": "Solidarisk",
  "guaranteeRelation.GuarantorInSolidarity": "Solidarisk",
  "guaranteeRelation.GuarantorProRata": "Pro rata",
  "guaranteeRelation.StakeHolderGuarantee": "Interessent",
  "guaranteeRelation.StakeHolderGuaranteeProRata": "Pro rata",
  "interestType.Fixed": "Fast",
  "interestType.Floating": "Variabelt",
  "interestType.Undefined": "Ikke tilgængelig",
  "liabilityType.ProRata": "Pro rata",
  "liabilityType.Solidarity": "Solidarisk",
  "liabilityType.Undefined": "$t(common:unavailable)",
  "loanCategory.BondLoan_one": "obligationslån",
  "loanCategory.BondLoan_other": "obligationslån",
  "loanCategory.ConstructionCredit_one": "byggekredit",
  "loanCategory.ConstructionCredit_other": "byggekreditter",
  "loanCategory.ContractLoan_one": "aftalelån",
  "loanCategory.ContractLoan_other": "aftalelån",
  "loanCategory.SubsidizedLoan_one": "støttet lån",
  "loanCategory.SubsidizedLoan_other": "støttede lån",
  "loanCategory.Swap": "$t(contract-loan:swap_other)",
  "loanCategory.Undefined": "$t(common:unavailable)",
  "mitId.MitIdErhverv": "Erhverv",
  "mitId.MitIdPrivat": "Privat",
  "rateFrequency.M1": "Månedlig",
  "rateFrequency.M12": "Årlig",
  "rateFrequency.M2": "Ikke tilgængelig",
  "rateFrequency.M3": "Kvartårlig",
  "rateFrequency.M4": "Ikke tilgængelig",
  "rateFrequency.M6": "Halvårlig",
  "rateFrequency.UnDefined": "$t(common:unavailable)"
}
